import prefetchItem from './helper/prefetchItem';
import TableView from 'mini-mail-list-store/lib/store/schema/TableView';
import { action } from 'satcheljs/lib/legacy';
import { LoadConversationItemActionSource } from 'owa-mail-store/lib/store/schema/LoadConversationItemActionSource';

/**
 * Prefetch utility that is responsible for doing 3 kinds of item Prefetches
 * 1. Prefetch a new item.
 * 2. Prefetch first N items in a tableView.
 * 3. Prefetch adjacent items to a given item.
 */

const PREFETCH_ADJACENT_DELAY_MS: number = 1000;

/**
 * Prefetches the given item
 * @param - itemId - id of the item that needs to be prefetched, currently only conversationId supported
 * @param - tableView - table view where in the item needs to prefetch
 * @param - updateIfExists - True if this was called as a result of row add or modified notification; false otherwise (prefetch)
 */
export function prefetchSingleItem(itemId: string, tableView: TableView, updateIfExists: boolean) {
    prefetchItem(
        itemId,
        tableView,
        updateIfExists /* updateIfExists */,
        LoadConversationItemActionSource.PrefetchSingleRow
    );
}

/**
 * Prefetch first N items. We would prefetch items after the initial load of the table.
 * @param - tableView - where we are trying to prefetch
 * @param - countToPrefetch - number of items we are trying to prefetch
 */
export let prefetchFirstN = action('prefetchFirstN')(function prefetchFirstN(
    tableView: TableView,
    countToPrefetch: number
): void {
    const maxRowsToPrefetch = Math.min(tableView.itemIds.length, countToPrefetch);
    for (let i = 0; i < maxRowsToPrefetch; i++) {
        const itemId = tableView.itemIds[i];
        prefetchItem(
            itemId,
            tableView,
            false /* updateIfExists */,
            LoadConversationItemActionSource.PrefetchFirstN
        );
    }
});

/**
 * Prefetches the next and previous items for a given row id
 * @param - itemId - id of the item of which the adjacent items are to be prefetched
 * @param - tableView - tableView in which the item needs to be prefetched
 */
export let prefetchAdjacentItemsOnDelay = action('prefetchAdjacentItemsOnDelay')(
    function prefetchAdjacentItemsOnDelay(itemId: string, tableView: TableView): void {
        // Prefetch adjacent items on delay to not block fetching of current item
        setTimeout(() => {
            const itemIndex = tableView.itemIds.indexOf(itemId);

            // Prefetch previous
            let itemIndexToPrefetch = itemIndex - 1;
            if (itemIndexToPrefetch >= 0) {
                prefetchItem(
                    tableView.itemIds[itemIndexToPrefetch],
                    tableView,
                    false /* updateIfExists */,
                    LoadConversationItemActionSource.PrefetchAdjacentRowsOnDelay
                );
            }

            // Prefetch next
            itemIndexToPrefetch = itemIndex + 1;
            if (itemIndexToPrefetch < tableView.itemIds.length) {
                prefetchItem(
                    tableView.itemIds[itemIndexToPrefetch],
                    tableView,
                    false /* updateIfExists */,
                    LoadConversationItemActionSource.PrefetchAdjacentRowsOnDelay
                );
            }
        }, PREFETCH_ADJACENT_DELAY_MS);
    }
);
